<template>
  <component :is="componentTag" v-if="banner.id" v-bind="componentAttrs">
    <v-card class="banner__card" :width="slideWidth" flat>
      <div class="wd-rounded-4px" :style="bannerImageStyle" />
      <h2
        v-if="isCategoryUiType && banner.description"
        class="banner__description wd-font-normal"
        :class="isMobile ? 'wd-my-2 wd-text-omd' : 'wd-my-4 wd-text-otempmd'"
      >
        {{ banner.description }}
      </h2>
      <p v-else class="banner__description wd-leading-22px !wd-mb-0">
        {{ banner.description }}
      </p>
    </v-card>
  </component>
</template>

<script setup lang="ts">
import type { Banner } from '@/view-models/common'
import { BannerActionType } from '@/view-models/common'

interface Props {
  isMobile?: boolean
  banner: Banner
  slideWidth?: number
  isSingleSlidePerView?: boolean
  isCategoryUiType?: boolean
  isImageSizeLarge?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  isMobile: false,
  slideWidth: 360,
  isSingleSlidePerView: false,
  isCategoryUiType: false,
  isImageSizeLarge: false,
})

const config = useRuntimeConfig()

const isDivTemplate = computed(() => props.banner.link_type === BannerActionType.None || props.banner.link_type === BannerActionType.FromCurrentPage)

const componentTag = computed(() => (isDivTemplate.value ? 'div' : 'a'))
const componentAttrs = computed(() => ({
  ...(props.banner.link_type === BannerActionType.FromCurrentPage ? { class: 'wd-cursor-pointer' } : {}),
  ...(isDivTemplate.value ? {} : { href: props.banner.link_target, target: '_blank' }),
}))

const bannerImage = computed(() => getImage(props.banner.cover_image || ''))
const bannerImageStyle = computed(() => {
  const { height, aspectRatio } = getBannerSlideStyle({
    isSingleSlidePerView: props.isSingleSlidePerView,
    isMobile: props.isMobile,
    isImageSizeLarge: props.isImageSizeLarge,
  })

  return {
    'background-image': `url('${bannerImage.value}')`,
    'background-position': 'center',
    'background-repeat': 'no-repeat',
    'background-size': 'cover',
    width: `${props.slideWidth}px`,
    height,
    'aspect-ratio': aspectRatio,
  }
})

function getImage(path: string) {
  return `${config.public.CDN_URI}${path}`
}
</script>

<style lang="scss" scoped>
.banner__card {
  .banner__description {
    color: $black50 !important;
    display: -webkit-box;
    text-overflow: ellipsis;
    white-space: normal;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
